import { Row } from "@components/Flex";
import { GoalIcon } from "@components/Goals/GoalIcon";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, BodySmall } from "@components/Typography";
import { i18n, Translations } from "@i18n";
import { getFullName, getInitials } from "@utils";
import { useStyles } from "./styles";
import { SharedGoalItemProps } from "./types";

export const SharedGoalItem = ({
  firstName,
  lastName,
  goalName,
  goalType,
}: SharedGoalItemProps) => {
  const styles = useStyles();

  const name = getFullName(firstName, lastName);
  const initials = getInitials(firstName, lastName);

  return (
    <div style={styles.container}>
      <div style={styles.left}>
        <Body>{goalName}</Body>
        <Spacing size={SpacingSizes.XXS} />

        <div style={styles.shared}>
          <Row>
            <BodySmall style={styles.sharedText}>
              {i18n.t(Translations.AcceptSharedGoalItemLabel, { name })}
            </BodySmall>
            <div style={styles.contact}>
              <BodySmall style={styles.contactText}>{initials}</BodySmall>
            </div>
          </Row>
        </div>
      </div>
      <div style={styles.right}>
        <GoalIcon size={30} type={goalType} />
      </div>
    </div>
  );
};
